require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/analytics/legacy/framework/events/AnalyticsEvent.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/analytics/legacy/framework/events/AnalyticsEvent.legacy.js
// module id = 795
// module chunks = 31